import React from 'react';
import Icon from '../app_components/Icon';
import { primitives } from '@lexody/design-tokens';

const FEATURES = [
  {
    icon: 'users-alt',
    iconBg: primitives.blue['500'],
    solid: false,
    title: 'Unlimited Connects',
    subtitle: 'Connect with as many learners as you want.',
  },
  {
    icon: 'search',
    iconBg: primitives.green['400'],
    title: 'Advanced Search Filters',
    subtitle: 'Find the right people, faster.',
  },
  {
    icon: 'clock',
    iconBg: primitives.yellow['400'],
    title: 'See Last Active',
    subtitle: 'Know when your matches are online.',
  },
  {
    icon: 'shield-check',
    iconBg: primitives.violet['600'],
    title: 'Exclusive Pro Badge',
    subtitle: "Stand out and show you're a pro.",
  },
  {
    icon: 'heart',
    iconBg: primitives.pink['500'],
    title: 'Support Lexody',
    subtitle: 'Your support helps Lexody grow!',
  },
];

function FeatureIcon({ feature }) {
  return (
    <div
      className="pricing-features__icon-wrap"
      style={{ backgroundColor: feature.iconBg }}
    >
      <Icon
        name={feature.icon}
        solid={feature.solid !== false}
        size={22}
        color="#fff"
      />
    </div>
  );
}

const ProFeaturesList = () => (
  <div className="pricing-features">
    <h2 className="pricing-features__heading">
      <span className="pricing-features__sparkle" aria-hidden="true">✨</span>
      Pro features you&apos;ll love
      <span className="pricing-features__sparkle" aria-hidden="true">✨</span>
    </h2>
    <div className="pricing-features__list">
      {FEATURES.map((feature) => (
        <div key={feature.title} className="pricing-features__item">
          <FeatureIcon feature={feature} />
          <div className="pricing-features__text">
            <p className="pricing-features__title">{feature.title}</p>
            <p className="pricing-features__subtitle">{feature.subtitle}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default ProFeaturesList;
